const API_DATE_REGEX = /^(\d{4})-(\d{2})-(\d{2})$/;
const POLISH_DATE_REGEX = /^(\d{2})\.(\d{2})\.(\d{4})$/;

export const INVOICE_DATE_FORMAT_ERROR_MESSAGE =
  'Nieprawidłowy format daty (DD.MM.RRRR lub YYYY-MM-DD)';

export const normalizeInvoiceDateInput = (originalValue: unknown): unknown => {
  if (typeof originalValue !== 'string') {
    return originalValue;
  }

  const value = originalValue.trim();
  if (!value) {
    return '';
  }

  const polishMatch = value.match(POLISH_DATE_REGEX);
  if (!polishMatch) {
    return value;
  }

  const [, day, month, year] = polishMatch;
  return `${year}-${month}-${day}`;
};

export const isValidInvoiceApiDate = (value: string | null | undefined): boolean => {
  if (!value) {
    return true;
  }

  const apiMatch = value.match(API_DATE_REGEX);
  if (!apiMatch) {
    return false;
  }

  const [, yearRaw, monthRaw, dayRaw] = apiMatch;
  const year = Number(yearRaw);
  const month = Number(monthRaw);
  const day = Number(dayRaw);

  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
  );
};
